import { Host, h } from '@stencil/core';
export class ModalSymply {
  constructor() {
    this.toggleOpenState = () => {
      this.open = !this.open;
    };
    this.text = undefined;
    this.open = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, null, h("div", { class: "icon-info-container", onClick: this.toggleOpenState }, h("div", { class: this.text ? 'icon-info icon-info_small' : 'icon-info' }), this.text && h("span", { class: "modal-icon-text" }, this.text)), h("div", { class: this.open ? 'modal-overlay' : 'modal-overlay hidden' }, h("div", { class: "modal-wrapper" }, h("button", { type: "button", class: "button-close", onClick: this.toggleOpenState }, h("div", { class: "icon-close" })), h("slot", null)))));
  }
  static get is() { return "pdp-modal-symply"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["modal-symply.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["modal-symply.css"]
    };
  }
  static get properties() {
    return {
      "text": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Info icon label"
        },
        "attribute": "text",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "open": {}
    };
  }
  static get elementRef() { return "el"; }
}
